<template>
    <div class="flex items-center justify-center w-full bg-blue-200 text-blue-700 text-center leading-tight py-3 px-3 sm:text-md">
        <div>Your free trial has expired, please subscribe to a plan.</div>

        <a v-if="! on_payment_route"
            :href="payment_route || '/broker/settings/account'"
        >
            <button-blue type="button" class="ml-6" size="small">
                {{ is_monthly || is_yearly ? 'Subscribe Now' : 'Pay Now' }}
            </button-blue>
        </a>
    </div>
</template>

<script>
import ButtonBlue from '../components/button-blue.vue';

export default {
    components: {
        ButtonBlue,
    },

    props: {
        payment_route: {},
        on_payment_route: { default: false },
        is_monthly: { default: true },
        is_yearly: { default: false },
    },
}
</script>
